import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import SvgIcon from 'components/SvgIcon/SvgIcon';
import CollatoFileShareModal from 'components/Collato/CollatoFileShareModal';

const AttachFileIcon = ({ onSendMessage, threadUser }) => {
  const [showAttachFileModal, setShowAttachFileModal] = useState(false);
  const handleClick = () => {
    setShowAttachFileModal(true);
  };
  return (
    <Fragment>
      <div role="button" onClick={handleClick} alt="send file as message">
        <SvgIcon icon="Paper_clip_font_awesome" size="27" />
      </div>
      <CollatoFileShareModal
        handleExit={() => setShowAttachFileModal(false)}
        show={showAttachFileModal}
        onSendLink={(messageContent, messageType) =>
          onSendMessage(threadUser, messageContent, messageType)
        }
      />
    </Fragment>
  );
};

AttachFileIcon.propTypes = {
  onSendMessage: PropTypes.func,
  threadUser: PropTypes.object,
};

export default AttachFileIcon;
